import { DropdownMenu, MenuItem } from '@reckon-web/dropdown';
import {
  ChevronDownIcon,
  ChevronUpIcon,
  ExternalLinkIcon,
} from '@reckon-web/icon';
import { Button } from '@reckon-web/button';
import { makeId } from '@reckon-web/utils';

import { useOpenNewJobDialog } from '../job/new-job-dialog';
import { useTaskDrawer } from '../task/task-drawer-context';
import { useGetMyDetails } from '../../data/useGetMyDetails';
import { canTUM } from '../../utils/user-security-utils';

export const AddNew = ({ testId = 'add-new' }) => {
  const openNewJob = useOpenNewJobDialog();
  const { openCreate: openNewTask } = useTaskDrawer();
  const currentUser = useGetMyDetails();

  return (
    <DropdownMenu
      trigger={({ isOpen, triggerProps }) => (
        <Button
          label="Add new"
          weight="bold"
          size="small"
          iconAfter={isOpen ? ChevronUpIcon : ChevronDownIcon}
          {...triggerProps}
          data-testid={makeId(testId, 'button')}
        />
      )}
    >
      <MenuItem
        label="Job"
        tone="active"
        onClick={() => openNewJob()}
        data-testid={makeId(testId, 'job')}
      />
      <MenuItem
        label="Task"
        tone="active"
        onClick={() => openNewTask()}
        data-testid={makeId(testId, 'task')}
      />
      {/* TODO */}
      {/* <MenuItem label="Template" tone="active" /> */}
      {canTUM(currentUser.data?.user) && (
        <MenuItem
          icon={ExternalLinkIcon}
          label="User"
          onClick={() => window.open(process.env.USERS_URL, '_blank')}
          tone="active"
          data-testid={makeId(testId, 'user')}
        />
      )}
      <MenuItem
        icon={ExternalLinkIcon}
        label="Client"
        onClick={() => window.open(process.env.CONTACTS_URL, '_blank')}
        tone="active"
        data-testid={makeId(testId, 'client')}
      />
    </DropdownMenu>
  );
};
